import * as React from 'react';
export const IcDeployment = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M22 17.68l-1-3a1 1 0 00-1-.68h-2.5a1 1 0 00.81-.42 1 1 0 00.14-.9l-1-3A1 1 0 0016.5 9h-2a1 1 0 00.81-.42 1 1 0 00.14-.9l-1-3A1 1 0 0013.5 4h-3a1 1 0 00-.95.68l-1 3a1 1 0 00.14.9A1 1 0 009.5 9H7a1 1 0 00-1 .68l-1 3a1 1 0 00.14.9A1 1 0 006 14H4a1 1 0 00-1 .68l-1 3a1 1 0 00.14.9A1 1 0 003 19h18a1 1 0 00.81-.42.999.999 0 00.19-.9zm-12.4-3L8.78 17h-.06L8 14.68A1 1 0 007 14h3.5a1 1 0 00-.95.68h.05zm3-5L11.78 12h-.06L11 9.68A1 1 0 0010 9h3.5a1 1 0 00-.95.68h.05zm3.5 5L15.28 17h-.06l-.77-2.32a1 1 0 00-.95-.68H17a1 1 0 00-.95.68h.05z'
      fill='currentColor'
    />
  </svg>
);
